import React from 'react'

import { Grid, Card,  Icon, IconButton } from "@mui/material";
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";

import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';

const Distributor = ({distributer, parseContent}) => {
  return (
    <Card>
      <Grid container p={{xs:.5, lg:1}} mx={{xs:0, lg:2}} alignItems="center" justifyContent="space-arround">
        <Grid item xs={4}>
          <MDBox
              component="img"
              src={`${process.env.REACT_APP_PUBLIC_URL}/img/distributer/${distributer.photoURL}`}
              alt={distributer.companyName === ""  || !distributer.companyName ? distributer.displayName : distributer.companyName}
              width="100%"
              position="relative"
              zIndex={1}
              onError={({ currentTarget }) => {
                /*eslint-disable*/
                currentTarget.onerror = null; // prevents looping
                currentTarget.src=`${process.env.REACT_APP_PUBLIC_URL}/img/user-default.png`;
              }}
              sx={{
                cursor:"pointer", borderRadius : "50%", border : "2px solid white", p:1, 
                backgroundColor :  ({ palette: { background }}) => background.card ,
                boxShadow:"sm"
              }}
              mt={-25}
          />
        </Grid>
        <Grid item xs={8}>
          <MDBox pb={2} px={{xs:.6, lg:2}} lineHeight={1.25}>
            <MDTypography variant="h5" fontWeight="medium" color="primary" textTransform="capitalize">
              {distributer.companyName === "" || !distributer.companyName ? distributer.displayName : `${distributer.raisonSociale !== "" ? distributer.raisonSociale : "" } ${distributer.companyName}`}
            </MDTypography>
            
            <MDBox>
              <Grid container spacing={1.5}>
                <Grid item xs={12} lg={6} >
                  <MDTypography variant="body2" >
                    <Icon sx={{color : "#277cbb", mx :1}}>phone</Icon>
                    {distributer.telephone}
                  </MDTypography>
                </Grid>
                <Grid item xs={12} lg={6} >
                <MDTypography variant="body2" >
                    <Icon sx={{color : "#277cbb", mx :1}}>email</Icon>
                    {distributer.email}
                  </MDTypography>
                </Grid>
                <Grid item xs={12} lg={6} >
                <MDTypography variant="body2" >
                    <Icon sx={{color : "#277cbb", mx :1}}>phone_iphone</Icon>
                    {distributer.mobile}
                  </MDTypography>
                </Grid>
                <Grid item xs={12} lg={6} >
                <MDTypography variant="body2" >
                    <Icon sx={{color : "#277cbb", mx :1}}>phone</Icon>
                    {distributer.website}
                  </MDTypography>
                </Grid>
              </Grid>
              <MDTypography variant="body2" >
                <Icon sx={{color : "primary.main", mx :1}}>location_on</Icon>
                {parseContent(distributer.location?.street)}
              </MDTypography>
              <MDTypography variant="body2" >
                <Icon sx={{color : "primary.main", mx :1}}>signpost</Icon>
                {parseContent(distributer.location?.state.province)}
              </MDTypography>
            </MDBox>
            
          </MDBox>
          
        </Grid>
        
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={2} lg={1}>
              <IconButton href={distributer.social.fb} target="_blank" sx={{color:'#1877F2',"&:hover":{color:'#0a60b2'}}}>
                <FacebookIcon />
              </IconButton>
            </Grid>
            <Grid item xs={2} lg={1} >
              <IconButton href={distributer.social.tweet} target="_blank" sx={{color:'#0d95e8',"&:hover":{color:'#1DA1F2'}}}>
                <TwitterIcon />
              </IconButton>
            </Grid>
            <Grid item xs={2} lg={1} >
              <IconButton href={distributer.social.insta} target="_blank" sx={{color:'#a12d6f',"&:hover":{color:'#C13584'}}}>
                <InstagramIcon />
              </IconButton>
            </Grid>
            <Grid item xs={2} lg={1} >
              <IconButton href={distributer.social.ytube} target="_blank" sx={{color:'#cc0000',"&:hover":{color:'#FF0000'}}}>
                <YouTubeIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  )
}

export default Distributor